import { ConsentAlertsPage } from './pages/consent-alerts/consent-alerts';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { Dashboard } from './pages/dashboard/dashboard';
import { Doctor } from './pages/doctor/doctor';
import { Products } from './pages/products/products';
import { RescueOrders } from './pages/rescue-orders/rescue-orders';
import { LoginPage } from './pages/auth/login/login.page';
import { GuardService } from './services/guard/guard.service';
import { RegulationPage } from './pages/regulation/regulation.page';
import { Dispatches } from './pages/dispatches/dispatches';
import { CommunicationsHistory } from './pages/communications-history/communications-history';

const routes: Routes = [

   { path: '', component: LoginPage },
   { path: 'regulation', component: RegulationPage },
    {
    path: 'home',
    component: LayoutComponent,
    canActivate: [GuardService],
    children: [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' ,},
    { path: 'dashboard', component: Dashboard },
    { path: 'consent-alerts', component: ConsentAlertsPage },
    { path: 'doctor', component: Doctor },
    { path: 'wishlist', loadComponent: () => import('./pages/wishlist/wishlist').then(m => m.WishlistPage) },
    { path: 'products', component: Products },
    { path: 'rescues', component: RescueOrders },
    { path: 'dispatches', component: Dispatches },
    { path: 'communications-history', component: CommunicationsHistory }
    ],
  },
  { path: '**', redirectTo: '' },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
